import classNames from 'classnames';
import styles from './CategoryCardPost.module.scss';
import { FC, ReactNode } from 'react';

interface CategoryCardPostProps {
	icon: ReactNode;
	title: string;
	subtitle: string;
	path: string;
	className?: string;
	iconMobileNone?: boolean;
}

const CategoryCardPost: FC<CategoryCardPostProps> = ({
	icon,
	subtitle,
	title,
	path,
	className,
	iconMobileNone
}) => {
	return (
		<div className={classNames(styles.categoryCard, className)}>
			<a className={styles.link} href={path}></a>
			{!iconMobileNone && <i className={styles.icon}>{icon}</i>}
			<h2>{title}</h2>
			<p>{subtitle}</p>
		</div>
	);
};

export default CategoryCardPost;
